import routes from './routes';
import { createRouter, createWebHistory } from 'vue-router';
import { track } from "../api/track-event";
import { setAuthState } from '../composables/auth';
import klaviyoApi from '../api/klaviyoApi';
import { useFeedbackButtonVisible } from "../composables/feedbackButton.composable";

import VueRouterMetaTags from '@bachdgvn/vue-router-meta-tags';

let { isAuthenticated, logout, isOnboardingComplete, getAfterOnboardingRedirect, getUser } = setAuthState();
const { hideFeedbackButton, showFeedbackButton } = useFeedbackButtonVisible();
let redirectAfterOnboarding = true;

const router = createRouter({ history: createWebHistory(), routes })

// check if route requires auth
let canUserAccess = (to) => {
    if (to.matched.some(record => record.meta.requiresAuth)) return isAuthenticated();
    return true
}

const IGNORE_ONBOARDING_REDIRECT_AFTER_REGISTER_ON_ROUTES = ['resumes.edit', 'community', 'job-board-search'];
const afterAuthPathRedirectKey = 'postAuthRedirect';

router.beforeEach(VueRouterMetaTags.update);
router.afterEach(() => {
    if(!isAuthenticated()) {
        hideFeedbackButton();
    }else{
        showFeedbackButton();
    }
});

// router.beforeEach((to, from) => {
//     if(to.name == "job-board-search" && from.name != 'job-board-onboarding' && !getUser()?.options?.job_board_onboarding_passed){
//         return { path: '/job-board/onboarding' }
//     }
//     else if(to.name == "job-board-onboarding" && from.name != 'job-board-search' && getUser()?.options?.job_board_onboarding_passed) {
//         return { path: '/job-board/search' }
//     }
// });

router.beforeEach(async (to, from) => {
    let urlParams = from.query;
    const isKlavioyPageTriggered = sessionStorage.getItem(`klaviyovisited: ${to.name}`) ?? false

    if(from.name === 'onboarding' && isOnboardingComplete() && redirectAfterOnboarding && localStorage.getItem('redirect_url') == null) {
        redirectAfterOnboarding = false;
        return { name: getAfterOnboardingRedirect() };
    }
    
    if(localStorage.getItem('redirect_url') != null && from.name === 'onboarding') {
        const url =  localStorage.getItem('redirect_url');
        const parsedUrl = new URL(url);
        const path = parsedUrl.pathname;
        const query = Object.fromEntries(parsedUrl.searchParams.entries());

        redirectAfterOnboarding = false;
        localStorage.removeItem('redirect_url');

        return { path, query };
    }
    
    if(!isOnboardingComplete() && to.name !== 'onboarding' && to.name !== '404' && isAuthenticated() && IGNORE_ONBOARDING_REDIRECT_AFTER_REGISTER_ON_ROUTES.indexOf(to.name) === -1) {
        return { path: '/onboarding', query: urlParams };
    }

    if (to.path === '/logout') {
        await logout()
        return { path: '/login', query: urlParams }
    }

    if (!isKlavioyPageTriggered && isAuthenticated()) {
        sessionStorage.setItem(`klaviyovisited:${to.name}`, true)
        klaviyoApi.sendKlaviyoEvent(getUser()?.email, to.name)
    }

    if(isAuthenticated() && canUserAccess(to) && sessionStorage.getItem(afterAuthPathRedirectKey) != null) {
        const redirectFullPath = JSON.parse(sessionStorage.getItem(afterAuthPathRedirectKey));
        sessionStorage.removeItem(afterAuthPathRedirectKey);
        
        router.push(redirectFullPath);
    }

    if (!canUserAccess(to)) {
        return { path: '/login', query: urlParams };
    }
})

router.afterEach((to) => {
    if(isAuthenticated()) {
        track({action_type: 'page_visit', action_description: to.name});
        localStorage.setItem('currentPage', to.fullPath);
    }
})

export default router
